import styled from 'styled-components';

const Stylesheet = styled.div`
  font-family: ${props => props.theme.V3.fonts.family};

  h1 {
    color: ${props => props.theme.V3.colors.text.title};
    font-size: ${props => props.theme.V3.fonts.h1.size}px;
    font-stretch: normal;
    font-style: normal;
    font-weight: normal;
    letter-spacing: ${props => props.theme.V3.fonts.h1.letterSpacing}px;
    line-height: normal;
    opacity: 0.9;
    margin: 0;
  }

  h2 {
    color: ${props => props.theme.V3.colors.text.title};
    font-size: ${props => props.theme.V3.fonts.h2.size}px;
    font-stretch: normal;
    font-style: normal;
    font-weight: normal;
    letter-spacing: ${props => props.theme.V3.fonts.h2.letterSpacing}px;
    line-height: normal;
    margin: 0;
  }
  
  h3 {
    color: ${props => props.theme.V3.colors.text.emphasis};
    font-size: ${props => props.theme.V3.fonts.h3.size}px;
    font-stretch: normal;
    font-style: normal;
    font-weight: normal;
    letter-spacing: ${props => props.theme.V3.fonts.h3.letterSpacing}px;
    line-height: normal;
    margin: 0;
  }

  h4 {
    color: ${props => props.theme.V3.colors.text.emphasis};
    font-size: ${props => props.theme.V3.fonts.h4.size}px;
    font-stretch: normal;
    font-style: normal;
    font-weight: normal;
    line-height: normal;
    letter-spacing: ${props => props.theme.V3.fonts.h4.letterSpacing}px;
    margin: 0;
  }

  body {
    font-size: ${props => props.theme.V3.fonts.body.size}px;
    letter-spacing: ${props => props.theme.V3.fonts.body.letterSpacing}px;
  }
  
  input {
    font-size: ${props => props.theme.V3.fonts.forms.input.size}px;
    letter-spacing: ${props => props.theme.V3.fonts.forms.input.letterSpacing}px;
  }
  
  [type="reset"], [type="submit"], 
  [type="button"]:not([class*="MuiIconButton"]), 
  button:not([class*="MuiIconButton"]) {
    font-weight: ${props => props.theme.V3.fonts.button.weight};
    font-size: ${props => props.theme.V3.fonts.button.size}px;
    letter-spacing: ${props => props.theme.V3.fonts.button.letterSpacing}px;
    
    height: ${props => props.theme.V3.metrics.form.input.height}px;
    
    :hover {
      cursor: pointer;
    }
  }
  
  .recharts-cartesian-axis-tick {    
    font-size: 13px;
    font-stretch: normal;
    font-style: normal;
    font-weight: normal;
    line-height: 3.38;
    letter-spacing: 0.16px;
    text-align: center;
  }

  .recharts-cartesian-axis-tick-value {
    fill: #000;
  } 
`;

export const Card = styled.div`
  background-color: ${props => props.theme.V3.colors.surface};
  box-shadow: ${props => props.theme.V3.boxShadow};
  display: flex;
  width: 100%;
`;

export const Metric = styled.div`
  color: ${props => props.color};
  font-size: ${props => props.theme.V3.fonts.metrics.size}px;
  font-stretch: normal;
  font-style: normal;
  font-weight: bold;
  line-height: normal;
  letter-spacing: ${props => props.theme.V3.fonts.metrics.letterSpacing}px;
`;

export const Container = styled.div`
  display: flex;
  margin-top: ${props => props.theme.V3.metrics.margin.normal}px;

  ${Card}:not(:last-child) {
    margin-right: ${props => props.theme.V3.metrics.margin.normal}px;
  }
`;

export const Spacer = styled.div`
  ${props => (props.horizontal ? 'height: 1px' : 'width: 1px')};
  ${props => props.horizontal && 'width: 100%'};
  background-color: ${props => props.theme.V3.colors.form.border};
`;

export const Input = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  
  color: black;
  height: ${props => props.theme.V3.metrics.form.input.height}px;
  padding: 0 ${props => props.theme.V3.metrics.form.input.padding}px;
  
  border: 1px solid ${props => props.theme.V3.colors.form.border};
  border-radius: ${props => props.theme.V3.metrics.form.border.radius}px;
  background-color: white;
  
  input {
    flex-grow: 2;
    height: 100%;
    
    border: none;
    background-color: transparent;
    
    font-size: ${props => props.theme.V3.fonts.forms.input.size}px;
    letter-spacing: ${props => props.theme.V3.fonts.forms.input.letterSpacing}px;
    
    :focus {
      outline: none;
    }
  }
`;

export default Stylesheet;



// WEBPACK FOOTER //
// ./src/statsradio/themes/v3/Stylesheet.js